'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _PATHS;

var _types = require('shared/modules/App/types');

var _types2 = require('shared/modules/Home/types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PATHS = (_PATHS = {}, (0, _defineProperty3.default)(_PATHS, _types.GET_APP, '/global'), (0, _defineProperty3.default)(_PATHS, _types2.GET_HOME, '/homepage'), _PATHS);

exports.default = PATHS;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/utils/Api/paths.js
// module id = 1305
// module chunks = 0